package com.tfc.care.tfccare

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.HTMLImageElement


class JsPlatform : Platform {
    override val name: String = "Web with Kotlin/JS"
}

actual fun getPlatform(): Platform = JsPlatform()


actual fun copyToClipboard(text: String) {
    window.navigator.clipboard.writeText(text)
}

actual suspend fun downloadImageFromUrl(
    imageUrl: String,
    fileName: String
) {
    val link = document.createElement("a") as HTMLAnchorElement
    link.href = imageUrl
    link.download = fileName
    document.body?.appendChild(link)
    link.click()
    document.body?.removeChild(link)
}

